import global$1 from './global.js';

var global = global$1;

var hostReportErrors = function (a, b) {
  var console = global.console;

  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

export { hostReportErrors as default };
